import { useGenericDemoteRole } from '@infuse/iam/role/mutations';
import { demoteTenantRole } from '@infuse/api/iam/tenant';

export const useDemoteTenantRole = () => {
  return useGenericDemoteRole({
    apiFn: demoteTenantRole
  });
};
